/**
 * Created by Ning Jiang on 2021-05-03.
 */
import {NolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/NolimitAudioPlayer";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {IFadeTrackConf, IPlayTrackConf} from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {gsap} from "gsap";
import {NolimitHowl} from "@nolimitcity/slot-audio/bin/NolimitHowl";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {OktoberfestGameConfig} from "../OktoberfestGameConfig";
import {IWinRatioConfig} from "../../core/config/WinRatio";

export class OktoberfestSound {

    public static MAIN_GAME_MUSIC: string = "background-music-main";
    public static FREESPIN: string = "background-music-fs";
    public static LOOP_NAME_EIN_PROSIT_MUSIC: string = "ein-prosit-music";
    public static LOOP_NAME_BAR_AMBIENCE: string = "bar-ambience";

    public static REELS_SPINNING: string = "wheels-spinning";
    public static REELS_LANDING: string[] = ["reel-one-landing", "reel-two-landing", "reel-three-landing", "reel-four-landing", "reel-five-landing"];

    public static SOUND_NAME_COUNTUP_LARGE: string = "countup-large";
    public static SOUND_NAME_COUNTUP_MEDIUM: string = "countup-medium";
    public static SOUND_NAME_COUNTUP_SMALL: string = "countup-small";
    public static SOUND_NAME_COUNTUP_ENDS: string = "countup-ends";
    public static INITIAL_LARGE: string = "win-large";
    public static INITIAL_MEDIUM: string = "win-medium";
    public static INITIAL_SMALL: string = "win-small";
    public static INITIAL_TINY: string = "low-win";
    public static AS_WIN: string = "asWin";
    public static AS_WIN_BIG: string = "asWinBig";
    public static SOUND_NAME_BETLINE_TURN_INTO_GOLD: string = "betline-turn-into-gold";
    public static SOUND_NAME_GOLD_SYMBOL_LANDING: string = "gold-symbol-landing";
    public static SOUND_NAME_WILD_CHEERS: string = "wild-cheers";

    public static SOUND_NAME_BIG_WIN_SMALL: string = "big-win-small";
    public static SOUND_NAME_BIG_WIN_MEDIUM: string = "big-win-mediumCut";
    public static SOUND_NAME_BIG_WIN_LARGE: string = "big-win-largeCut";
    public static SOUND_NAME_BIG_WIN_ENDS: string = "big-win-ends";

    public static SOUND_NAME_STACKED_REEL_LANDING: string = "stacked-reel-landing";
    public static SOUND_NAME_ANTICIPATION_REEL_FOUR_CHEERING_MODE: string = "anticipation-reel-four-cheering-mode";
    public static SOUND_NAME_WOMAN_APPEARS: string = "woman-appears";
    public static SOUND_NAME_MAN_APPEARS: string = "man-appears";
    public static SOUND_NAME_EIN_PROSIT_INTRO: string = "ein-prosit-intro";
    public static SOUND_NAME_CHEERS: string = "cheers";

    public static SOUND_NAME_ANTICIPATION_REEL_FIVE: string = "anticipation-reel-five";
    public static SOUND_NAME_ANTICIPATION_REEL_FOUR: string = "anticipation-reel-four";
    public static SOUND_NAME_ANTICIPATION_REEL_THREE: string = "anticipation-reel-three";
    public static SOUND_NAME_ANTICIPATION_REEL_TWO: string = "anticipation-reel-two";
    public static SOUND_NAME_ANTICIPATION_REEL_ONE: string = "anticipation-reel-one";

    public static SOUND_NAME_SCATTER: string = "scatter";
    public static SOUND_NAME_ANTICIPATION_FAIL: string = "anticipation-fail";

    public static SOUND_NAME_FS_ENDS: string = "fs-ends";
    public static SOUND_NAME_FS_METER_UP: string = "fs-meter-up";
    public static SOUND_NAME_FS_METER_UP_NEW_LEVEL: string = "fs-meter-up-new-level";
    public static SOUND_NAME_FS_METER_DOWN: string = "fs-meter-down";
    public static SOUND_NAME_FS_METER_ENTERS: string = "fs-meter-enters";
    public static SOUND_NAME_FS_MULTIPLIER_UP: string = "fs-multiplier-up";
    public static SOUND_NAME_FS_MULTIPLIER_WIN: string = "fs-multiplier-win";
    public static SOUND_NAME_FS_PANNING_SCREEN: string = "fs-panning-screen";
    public static SOUND_NAME_FS_SCATTER_INFO_TEXT: string = "fs-scatter-info-text";
    public static SOUND_NAME_FS_START_BUTTON_ENTERS: string = "fs-start-button-enters";
    public static SOUND_NAME_FS_WIN_BANNER: string = "fs-win-banner";
    public static SOUND_NAME_FS_MORE_SPINS: string = "fs-more-spins";

    public static SOUND_NAME_PM_MARCHING_DRUM: string = "pm-marching-drum";
    public static SOUND_NAME_PM_REEL_FIVE_LANDING: string = "pm-reel-five-landing";
    public static SOUND_NAME_PM_STACKED_REEL_LANDING: string = "pm-stacked-reel-landing";
    public static SOUND_NAME_PM_TURN_INTO_WILD: string = "pm-turn-into-wild";
    public static SOUND_NAME_PM_WILD_LIGHTS_UP: string = "pm-wild-lights-up";
    public static SOUND_NAME_PM_WIN_BANNER: string = "pm-win-banner";

    public static SOUND_NAME_VOICE_HYPNOTIC_HORNS: string = "voice-hypnotic-horns";
    public static SOUND_NAME_VOICE_KOOL_KEGS: string = "voice-kool-kegs";
    public static SOUND_NAME_VOICE_PRETZEL_PARTY: string = "voice-pretzel-party";
    public static SOUND_NAME_VOICE_AWESOME_ACCORDIANS: string = "voice-awesome-accordians";
    public static SOUND_NAME_VOICE_SUPER_SAUSAGES: string = "voice-super-sausages";
    public static SOUND_NAME_VOICE_HAPPY_HATS: string = "voice-happy-hats";

    private static _currentMusic: string;

    constructor() {
    }

    public static get soundPlayer(): NolimitAudioPlayer {
        return <NolimitAudioPlayer>SlotGame.sound;
    }

    public static switchMusic(conf: IPlayTrackConf, fadeInConf?: IFadeTrackConf, fadeOutConf?: IFadeTrackConf): void {
        if (conf.name === OktoberfestSound._currentMusic) {
            return;
        }
        if (OktoberfestSound._currentMusic != null) {
            if (fadeOutConf) {
                fadeOutConf.name = this._currentMusic;
                const fade = OktoberfestSound.soundPlayer.fadeTrack(fadeOutConf);
                const fadeName = fadeOutConf.name;
                if (fade) {
                    const fadeName = this._currentMusic;
                    gsap.to(this, {
                        duration: fadeOutConf.duration / 1000, onComplete: () => {
                            OktoberfestSound.soundPlayer.stopTrack(fadeName);
                        }
                    });
                } else {
                    OktoberfestSound.soundPlayer.stopTrack(fadeName);
                }
            } else {
                OktoberfestSound.soundPlayer.stopTrack(OktoberfestSound._currentMusic);
            }
        }

        OktoberfestSound.soundPlayer.playTrack(conf);
        if (fadeInConf) {
            fadeInConf.name = conf.name;
            OktoberfestSound.soundPlayer.fadeTrack(fadeInConf);
        }
        OktoberfestSound._currentMusic = conf.name;
    }

    // Use this to handle the music, eg, fade out/in music in big win, and you don't need to care what music is playing
    public static fadeMusic(vol: number, duration: number): void {
        OktoberfestSound.soundPlayer.fadeTrack({
            name: OktoberfestSound._currentMusic,
            to: vol,
            duration: duration
        });
    }

    public static playSoundEffect(name: string, repeat?: number, volume?: number): NolimitHowl | undefined {
        if (!name) debugger;
        Logger.logDev("sound playSoundEffect:", name, repeat, volume);
        return this.soundPlayer.playTrack({
            name: name,
            repeat: repeat,
            volume: volume
        });
    }

    public static getMusicNameByMode(mode: GameMode | string): string {
        switch (mode) {
            case GameMode.FREESPIN:
                return OktoberfestSound.FREESPIN;
            case "WILD_" + GameMode.RESPIN:
                return OktoberfestSound.LOOP_NAME_EIN_PROSIT_MUSIC;
            default:
                return OktoberfestSound.MAIN_GAME_MUSIC;
        }
    }

    public static getAnticipationSound(reelId: number): string {
        switch (reelId) {
            case 0:
                return OktoberfestSound.SOUND_NAME_ANTICIPATION_REEL_ONE;
            case 1:
                return OktoberfestSound.SOUND_NAME_ANTICIPATION_REEL_TWO;
            case 2:
                return OktoberfestSound.SOUND_NAME_ANTICIPATION_REEL_THREE;
            case 3:
                return OktoberfestSound.SOUND_NAME_ANTICIPATION_REEL_FOUR;
            case 4:
                return OktoberfestSound.SOUND_NAME_ANTICIPATION_REEL_FIVE;
            default:
                return OktoberfestSound.SOUND_NAME_ANTICIPATION_REEL_ONE
        }
    }

    public static getNormalWinSoundName(winRatio: IWinRatioConfig): string {
        //Tiny
        if (winRatio.ratio < OktoberfestGameConfig.WIN_RATIOS[1].ratio) {
            return OktoberfestSound.INITIAL_TINY;
        }
        //small
        if (winRatio.ratio < OktoberfestGameConfig.WIN_RATIOS[2].ratio) {
            return OktoberfestSound.INITIAL_SMALL;
        }
        //Medium
        if (winRatio.ratio < OktoberfestGameConfig.WIN_RATIOS[3].ratio) {
            return OktoberfestSound.INITIAL_MEDIUM;
        }
        //Large
        if (winRatio.ratio < OktoberfestGameConfig.WIN_RATIOS[4].ratio) {
            return OktoberfestSound.INITIAL_LARGE;
        }
        return OktoberfestSound.INITIAL_TINY;
    }
}
